import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const TacticP2BAddiko = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="addiko-kredit.webp" xPos="71%" yPos="40%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Urejene finance z več nadzora.</h1>
                    <p className="text-left">
                      Kredit, ki ste ga sklenili pri nas (ali pri našem partnerju Leanpay), lahko <b>prilagodite svojim trenutnim potrebam in s tem:</b>                       
                    </p>
                    <ul className="mt-3">
                      <li>
                        poplačate obstoječe obveznosti,
                      </li>
                      <li>
                        združite vse v en mesečni obrok,
                      </li>
                      <li>
                        pridobite dodatna sredstva za druge načrte.
                      </li>
                    </ul>
                    <p className="text-left">
                      Vas zanima več? Sporočite nam svoje kontaktne podatke in v kratkem vas pokličemo!
                    </p>
                    <p className="text-left text-small">
                        <b>Kjerkoli in kadarkoli, vedno z vami!</b><br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="03930c38-5857-482c-924f-1c4dca611318" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}